/* eslint-disable react/prop-types */
import React, { forwardRef, useEffect, Suspense } from 'react';
import { StyleSheet } from 'react-native';
import { Modalize } from 'react-native-modalize';
import { Portal } from '@gorhom/portal';
// import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { isWeb, isMobileWeb } from '~global/screens';
//
import Colors from '~global/Colors';

// eslint-disable-next-line react/display-name
const ModalizeBase = forwardRef((props, ref) => {
  // const insets = useSafeAreaInsets();
  const {
    children,
    dash = false,
    handleStyle,
    modalStyle,
    overlayStyle,
    canClose = true,
    // withInsetsBottom,
  } = props;
  const modalizeProps = {
    ...props,
    // ...(withInsetsBottom && {
    //   childrenStyle: [{ paddingBottom: insets.bottom }],
    // }),
    ref,
    handleStyle: [styles.handleStyle, handleStyle],
    modalStyle: [styles.modalStyle, modalStyle],
    overlayStyle: [styles.overlayStyle, overlayStyle],
    withHandle: isMobileWeb || dash ? true : false,
    closeOnOverlayTap: canClose,
    closeSnapPointStraightEnabled: canClose,
  };

  if (props.fullScreen) {
    modalizeProps.withHandle = false;
    modalizeProps.modalStyle = [
      StyleSheet.flatten(styles.modalStyleFull),
      modalStyle,
    ];
    delete modalizeProps.overlayStyle;
    delete modalizeProps.handleStyle;
  }

  if (props.center) {
    modalizeProps.withHandle = false;
    modalizeProps.modalStyle = [
      StyleSheet.flatten(styles.modalStyleCenter),
      modalStyle,
    ];
    delete modalizeProps.handleStyle;
  }

  // disabled gesture on web dekstop
  if (global.isWeb || props.fullScreen) {
    modalizeProps.tapGestureEnabled = false;
    modalizeProps.closeSnapPointStraightEnabled = false;
    modalizeProps.panGestureEnabled = false;
  }

  useEffect(() => {
    if (props && Object.keys(props).includes('refReady')) {
      props.refReady(true);
    }
  }, []);

  return (
    <Portal hostName="modalize_host">
      <Suspense fallback={<></>}>
        <Modalize {...modalizeProps}>{children}</Modalize>
      </Suspense>
    </Portal>
  );
});

ModalizeBase.defaultProps = { adjustToContentHeight: true };

const styles = StyleSheet.create({
  handleStyle: {
    backgroundColor: Colors.grey0,
    top: 26,
    width: 38,
    height: 3,
  },
  modalStyle: {
    backgroundColor: Colors.white,
    borderRadius: 8,
    overflow: 'hidden',
    ...(isMobileWeb
      ? {
          borderRadius: 0,
          borderTopLeftRadius: 8,
          borderTopRightRadius: 8,
          marginTop: 'auto',
          marginBottom: 0,
          marginHorizontal: 0,
        }
      : {
          margin: 'auto',
        }),
  },
  modalStyleFull: {
    backgroundColor: Colors.white,
    overflow: 'hidden',
    borderRadius: 0,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  },
  modalStyleCenter: {
    backgroundColor: Colors.white,
    overflow: 'hidden',
    borderRadius: 8,
    margin: 'auto',
  },
  overlayStyle: {
    backgroundColor: Colors.overlay,
    ...(isWeb && { position: 'fixed' }),
  },
});

export default ModalizeBase;
